import { useProfileStore } from '../store/useProfileStore';
import { isContentAdmin } from '../types/profile';

export interface MenuItem {
  label: string;
  path: string;
  icon?: string;       // SVG image path
  ionIcon?: string;    // ionicon name
  shouldShow?: () => boolean;
  isMain?: boolean;
}

export const robotOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M256 48v64' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><circle cx='256' cy='48' r='24' fill='none' stroke='currentColor' stroke-width='32'/><rect x='80' y='112' width='352' height='320' rx='48' fill='none' stroke='currentColor' stroke-width='32'/><circle cx='192' cy='256' r='32' fill='none' stroke='currentColor' stroke-width='32'/><circle cx='320' cy='256' r='32' fill='none' stroke='currentColor' stroke-width='32'/><path d='M192 344h128' fill='none' stroke='currentColor' stroke-linecap='round' stroke-width='32'/><path d='M48 240h32M432 240h32' fill='none' stroke='currentColor' stroke-linecap='round' stroke-width='32'/></svg>";

export const menuItems: MenuItem[] = [
  { label: 'Dashboard', path: '/dashboard', ionIcon: 'barChartOutline', isMain: true },
  { label: 'Clients', path: '/clients', ionIcon: 'peopleCircleOutline' },
  { label: 'Users', path: '/users', ionIcon: 'personOutline' },
  { label: 'Calls', path: '/calls', ionIcon: 'callOutline' },
  { label: 'Call Reports', path: '/call-report', ionIcon: 'barChartOutline' },
  { label: 'AI Agents', path: '/ai-agents', ionIcon: 'robotOutline' },
  { label: 'From Numbers', path: '/phone-numbers', ionIcon: 'keypadOutline' },
  { label: 'Voices', path: '/voices', ionIcon: 'micCircleOutline' },
  {
    label: 'Content',
    path: '/content',
    ionIcon: 'bookOutline',
    shouldShow: () => isContentAdmin(useProfileStore.getState().activeProfile),
  },
];
